var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{ref:"el",attrs:{"value":_vm.result},on:{"input":_vm.checked}})
}
var staticRenderFns = []

export { render, staticRenderFns }